import { RootStateType, SequencesStateType } from './sequences';

import { SequenceStates } from 'defs/sequences/utils';

export const getSequences = (state: RootStateType): SequencesStateType => {
	return state.sequences || {};
};

export const getSequenceIsRunning = (state: RootStateType, sequence: string): boolean => {
	return getSequences(state)[sequence] === SequenceStates.RUNNING;
};

export const getSequenceKeys = (state: RootStateType): string[] => {
	return Object.keys(getSequences(state));
};

export const getSequenceExists = (state: RootStateType, sequence: string): boolean => {
	return !!getSequences(state)[sequence];
};

export const getSequencesByName = (state: RootStateType, filterSequenceNames: string[]) => {
	const sequences = getSequences(state);
	const filteredSequences: { [sequence: string]: string } = {};

	for (const sequenceName in sequences) {
		if (~filterSequenceNames.indexOf(sequenceName)) {
			filteredSequences[sequenceName] = sequences[sequenceName];
		}
	}

	return filteredSequences;
};
